import { FC, Suspense } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { PlatformStatisticResult } from '@/api/statistic/types';
import { TranslationNamespace } from '@/i18n';

import { getFormatedNumber } from './FishplaceNumbers.utils';
import { JoinButton } from './JoinButton';

import styles from './FishplaceNumbers.module.scss';

type Props = {
	descriptions: string[];
	statistic?: PlatformStatisticResult | null;
};

export const FishplaceNumbers: FC<Props> = ({ descriptions, statistic }) => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	return (
		<section className={styles.fishplaceInNumbers}>
			<div className={styles.content}>
				<div className={styles.descriptionBlock}>
					<h2 className={styles.title}>{t('about-us-container.fishplace-in-numbers')}</h2>
					<div className={styles.descriptions}>
						{descriptions.map((text) => (
							<div key={text}>{text}</div>
						))}
					</div>
					<Suspense fallback={null}>
						<JoinButton />
					</Suspense>
				</div>

				<div className={styles.numbers}>
					{getFormatedNumber(statistic, t).map(({ title, description }, index) => (
						<div key={`${title}-${index}`} className={styles.numberItem}>
							<div className={styles.numberTitle}>{title}</div>
							<div className={styles.numberDescription}>{description}</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};
